var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import ContainerPainel from '../../../components/container_painel';
import { verificarUsuarioLogado, getURLMTLogout } from '../../../services/mt_login';
import { PAGINAS } from '../../../routes';
import LogoFunac from '../../../public/nova_chance_logo.png';
import { useAuth } from '../../../contexts/auth/AuthContext';
var HomePainel = function () {
    var _a = useAuth(), User = _a.User, signInContext = _a.signInContext, DEV = _a.DEV;
    useEffect(function () {
        DEV && printarVariaveisAmbiente();
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var printarVariaveisAmbiente = function () {
        console.log('process.env.PORTAL_URL', process.env.PORTAL_URL);
        console.log('process.env', process.env);
        console.log('process.env', JSON.stringify(process.env));
    };
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isBypass, Resp;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    console.log('[HOME] carregarDados iniciado');
                    console.log('[HOME] User já existe no contexto:', !!User);
                    isBypass = String((_a = process.env.DEV_LOGIN_BYPASS_ENABLED) !== null && _a !== void 0 ? _a : '').toLowerCase() === 'true';
                    if (!(User && !isBypass)) return [3 /*break*/, 1];
                    console.log('[HOME] Usuário já autenticado:', (_b = User === null || User === void 0 ? void 0 : User.nome) !== null && _b !== void 0 ? _b : '(sem nome)');
                    return [3 /*break*/, 3];
                case 1:
                    console.log('[HOME] Nenhum usuário em contexto — iniciando verificarUsuarioLogado...');
                    return [4 /*yield*/, verificarUsuarioLogado()];
                case 2:
                    Resp = _c.sent();
                    console.log('[HOME] Retorno de verificarUsuarioLogado:', {
                        status_code: Resp === null || Resp === void 0 ? void 0 : Resp.status_code,
                        tipo_erro: Resp === null || Resp === void 0 ? void 0 : Resp.tipo_erro,
                        possui_usuario: !!(Resp === null || Resp === void 0 ? void 0 : Resp.usuario),
                    });
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.status_code) == 400 || (Resp === null || Resp === void 0 ? void 0 : Resp.status_code) == 401 || (Resp === null || Resp === void 0 ? void 0 : Resp.status_code) == 403) {
                        console.error('[HOME] Falha no login. tipo_erro:', Resp.tipo_erro);
                        switch (Resp.tipo_erro) {
                            case 'erro_sem_variavel_code':
                                alert('Erro ao executar a solicitação. Nenhuma variável Code foi encontrada.');
                                break;
                            case 'erro_executar_solicitacao_mt_login_token':
                                alert('Erro ao executar a solicitação. Permissão de acesso negada no MTLogin.');
                                break;
                            case 'erro_executar_solicitacao_dados_usuario_api':
                                alert('Erro ao executar a solicitação. Erro ao consultar os dados do Usuário na API.');
                                break;
                            case 'usuario_nao_cadastrado':
                                alert('Permissão de acesso negada. Usuário não cadastrado.');
                                break;
                            case 'usuario_inativo':
                                alert('Permissão de acesso negada. Usuário inativo.');
                                break;
                            case 'usuario_sem_permissao':
                                alert('Permissão de acesso negada. Usuário sem permissões de acesso.');
                                break;
                            case 'token_invalido':
                                alert('O Token de acesso enviado é inválido, ou usuário não encontrando');
                                break;
                            case 'erro_desconhecido':
                                console.error('[HOME] Erro desconhecido:', Resp.message);
                                alert('Erro ao executar a solicitação. Tente novamente mais tarde.');
                                break;
                            default:
                                console.error('[HOME] tipo_erro não mapeado:', Resp.tipo_erro);
                                alert('Erro ao executar a solicitação. Tente novamente mais tarde.');
                                break;
                        }
                        console.log('[HOME] Redirecionando para logout:', getURLMTLogout());
                        window.location.href = getURLMTLogout();
                    }
                    else {
                        console.log('[HOME] Login bem-sucedido. Chamando signInContext...');
                        signInContext(Resp.usuario);
                    }
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ pagina: PAGINAS.HOME_PAINEL }, { children: _jsx(Box, __assign({ justifyContent: 'center', display: 'flex', flexDirection: 'column', p: 1 }, { children: _jsx(Box, __assign({ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1 }, { children: _jsx("img", { src: LogoFunac, alt: 'Logo funac', style: { width: '100%', maxWidth: '300px' } }) })) })) })));
};
export default HomePainel;
